var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"char-counter-container"},[_c('span',{directives:[{name:"visible",rawName:"v-visible",value:(_vm.showCount),expression:"showCount"}],class:_vm.spanClass},[_vm._v(_vm._s(_vm.cnt)+"/120")])])
}
var staticRenderFns = []

export { render, staticRenderFns }